<template>
  <q-uploader
    color="primary"
    style="width: 100%"
    hide-upload-btn
    flat
    bordered
    :label="label"
    :accept=accept
    @added="addFiles"
    @removed="removeFiles"
  />
</template>

<script>
import azureUpload from "./libs/azure-upload";
export default {
  name: "azureUploader",

  props: {
    label: String,
    account: String,
    sas: String,
    containerName: String,
    path: String,
    accept: String
  },

  data() {
    return {
      isFilesAttached: false,
      files: [],
      azure: {}
    };
  },

  methods: {
    async upload() {
      if (!this.isFilesAttached) {
        alert(this.label + ' error');
        return Promise.reject("Upload aborted: No files were attached.");
      }

      let files = this.files;

      let config = {
        account: this.account,
        sas: this.sas,
        containerName: this.containerName,
        path: this.path
      };

      await azureUpload(files, config)
        .then(resp => this.$set(this, 'azure', resp))
        .catch(err => reject(err));

      return new Promise((resolve, reject) => {
        this.toBase64(this.azure.url)
          .then(encoded => {
            resolve({
              azure: this.azure,
              encoded: encoded
            });
          })
          .catch(err => reject(err))
      });
    },

    addFiles(files) {
      this.files = files;
      this.isFilesAttached = true;
    },

    removeFiles() {
      this.files = [];
      this.isFilesAttached = false;
    },

    toBase64(url) {
      return new Promise((resolve, reject) => {
        try {
          let file = this.files.reduce((init, v) => v, [])
          let fileReader = new FileReader();
          fileReader.onload = function(fileLoadedEvent) {
            let encoded = fileLoadedEvent.target.result;
            resolve(encoded)
          };
          fileReader.readAsDataURL(file);
        }
        catch(err) {
          reject(err)
        }
      });
    }
  }
};
</script>
